import _regeneratorRuntime from "@babel/runtime/regenerator";
var _marked = /*#__PURE__*/_regeneratorRuntime.mark(loop),
  _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(rootSaga);
import { all, fork } from 'redux-saga/effects';
import PageSagas from '../pagesContents/Page/sagas';
import LoginSagas from '../pagesContents/Login/sagas';
import AboutSagas from '../pagesContents/About/sagas';
import ScholarshipSagas from '../pagesContents/Scholarship/sagas';
import SubmitSchoolSagas from '../pagesContents/SubmitSchool/sagas';
import DisclaimerSagas from '../pagesContents/Disclaimer/sagas';
import StartSagas from '../pagesContents/Start/sagas';
import ApplicationCvSagas from '../pagesContents/ApplicationCv/sagas';
import ApplicationBackgroundSagas from '../pagesContents/ApplicationBackground/sagas';
import ApplicationPersonalSagas from '../pagesContents/ApplicationPersonal/sagas';
import ApplicationSubmitSagas from '../pagesContents/ApplicationSubmit/sagas';
import ThankyouSagas from '../pagesContents/Thankyou/sagas';
import ForgotPasswordSagas from '../pagesContents/ForgotPassword/sagas';
import ResetPasswordSagas from '../pagesContents/ResetPassword/sagas';
import PrintCandidacySagas from '../pagesContents/PrintCandidacy/sagas';
import ApiSagas from './api/sagas';
import AppSagas from './app/sagas';
import AuthSagas from './auth/sagas';
import TranslationSagas from './i18n/sagas';
var entities = [PageSagas, LoginSagas, AboutSagas, ScholarshipSagas, SubmitSchoolSagas, DisclaimerSagas, StartSagas, ApplicationCvSagas, ApplicationBackgroundSagas, ApplicationPersonalSagas, ApplicationSubmitSagas, ThankyouSagas, ForgotPasswordSagas, ResetPasswordSagas, PrintCandidacySagas, ApiSagas, AppSagas, AuthSagas, TranslationSagas];
function loop() {
  return _regeneratorRuntime.wrap(function (_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 1;
        return all(entities.map(function (entity) {
          return entity.loop();
        }));
      case 1:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
export default function rootSaga() {
  return _regeneratorRuntime.wrap(function (_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 1;
        return fork(loop);
      case 1:
      case "end":
        return _context2.stop();
    }
  }, _marked2);
}